import React, { useState, useRef, useMemo, forwardRef, useImperativeHandle, useEffect } from 'react';
import JoditEditor from 'jodit-react';

const PackageDescription = forwardRef(({ placeholder = 'Start typing...', initialValue = '', onContentChange }, ref) => {
  const editor = useRef(null);
  const [content, setContentState] = useState(initialValue);

  useEffect(() => {
    setContentState(Array.isArray(initialValue) ? initialValue.join("\n") : initialValue || '');
  }, [initialValue]);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder,
      toolbarSticky: true,
      showXPathInStatusbar: false,
      height: 300,
    }),
    [placeholder]
  );

  const handleChange = (newContent) => {
    setContentState(newContent);
    if (typeof onContentChange === 'function') {
      onContentChange(newContent);
    }
  };

  useImperativeHandle(
    ref,
    () => ({
      getContent: () => content,
      setHtml: (html) => {
        setContentState(html);
        if (typeof onContentChange === 'function') {
          onContentChange(html);
        }
      },
      getEditorInstance: () => editor.current,
    }),
    [content, onContentChange]
  );

  return (
    <div className="my-3">
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        tabIndex={1}
        onBlur={(newContent) => handleChange(newContent)}
        onChange={(newContent) => handleChange(newContent)}
      />
    </div>
  );
});

export default PackageDescription;
